module.exports = __webpack_public_path__ + "static/media/img008.d83b869a.jpg";